import { useEffect, useState } from "react";

const API = "/api";
const token = () => localStorage.getItem("token");

export default function Vendedores() {
  const [vendedores, setVendedores] = useState<any[]>([]);
  const [form, setForm] = useState({ nombre: "", telefono: "" });
  const [editId, setEditId] = useState<number | null>(null);
  const [mostrarForm, setMostrarForm] = useState(false);

  const cargar = () => {
    fetch(`${API}/contado/vendedores`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setVendedores(d)).catch(() => {});
  };
  useEffect(() => { cargar(); }, []);

  const guardar = async () => {
    const url = editId ? `${API}/contado/vendedores/${editId}` : `${API}/contado/vendedores`;
    const method = editId ? "PUT" : "POST";
    const r = await fetch(url, {
      method, headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify(form),
    });
    if (r.ok) {
      setForm({ nombre: "", telefono: "" });
      setEditId(null);
      setMostrarForm(false);
      cargar();
    }
  };

  const editar = (v: any) => {
    setForm({ nombre: v.nombre, telefono: v.telefono || "" });
    setEditId(v.id);
    setMostrarForm(true);
  };

  const toggleActivo = async (id: number) => {
    await fetch(`${API}/contado/vendedores/${id}/desactivar`, {
      method: "PUT", headers: { Authorization: `Bearer ${token()}` },
    });
    cargar();
  };

  const input = { width: "100%", padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif", boxSizing: "border-box" as const };
  const label = { display: "block", fontSize: "12px", fontWeight: 700, color: "#6b7280", marginBottom: "4px" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
        <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, color: "#1a1a2e" }}>
          Vendedores ({vendedores.length})
        </h1>
        <button onClick={() => { setForm({ nombre: "", telefono: "" }); setEditId(null); setMostrarForm(!mostrarForm); }}
          style={{ background: "#0D47A1", color: "#fff", border: "none", borderRadius: "12px", padding: "10px 20px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          {mostrarForm ? "Cancelar" : "+ Nuevo Vendedor"}
        </button>
      </div>

      {mostrarForm && (
        <div style={{ background: "#fff", borderRadius: "16px", padding: "24px", marginBottom: "24px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", alignItems: "end" }}>
          <div>
            <label style={label}>Nombre *</label>
            <input style={input} value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} />
          </div>
          <div>
            <label style={label}>Teléfono</label>
            <input style={input} value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} />
          </div>
          <button onClick={guardar} disabled={!form.nombre}
            style={{ gridColumn: "1 / -1", background: "#1565C0", color: "#fff", border: "none", borderRadius: "12px", padding: "12px 28px", fontWeight: 800, cursor: form.nombre ? "pointer" : "not-allowed", opacity: form.nombre ? 1 : 0.5, fontFamily: "Nunito,sans-serif" }}>
            {editId ? "Guardar cambios" : "Crear vendedor"}
          </button>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {vendedores.map(v => (
          <div key={v.id} style={{ background: "#fff", borderRadius: "16px", padding: "16px 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center", opacity: v.activo ? 1 : 0.5 }}>
            <div>
              <div style={{ fontWeight: 800, fontSize: "15px" }}>{v.nombre}</div>
              {v.telefono && <div style={{ fontSize: "13px", color: "#6b7280" }}>📞 {v.telefono}</div>}
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={() => editar(v)}
                style={{ background: "#EFF6FF", color: "#1565C0", border: "none", borderRadius: "8px", padding: "6px 14px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}>
                Editar
              </button>
              <button onClick={() => toggleActivo(v.id)}
                style={{ background: v.activo ? "#FEF2F2" : "#ECFDF5", color: v.activo ? "#991B1B" : "#065F46", border: "none", borderRadius: "8px", padding: "6px 14px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}>
                {v.activo ? "Desactivar" : "Activar"}
              </button>
            </div>
          </div>
        ))}
        {vendedores.length === 0 && (
          <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
            No hay vendedores registrados aún
          </div>
        )}
      </div>
    </div>
  );
}
